import './s2e-preview-select.scss';
import layoutOneRectangle from '../../../../../../../images/previews/s2e-screen/layout-one-rectangle.svg';
import layoutTwoRectangles from '../../../../../../../images/previews/s2e-screen/layout-two-rectangles.svg';
import layoutThreeRectangles from '../../../../../../../images/previews/s2e-screen/layout-three-rectangles.svg';
import layoutTwoSquares from '../../../../../../../images/previews/s2e-screen/layout-two-squares.svg';
import layoutFourSquares from '../../../../../../../images/previews/s2e-screen/layout-four-squares.svg';
import customizationStore from '../../../../../../../stores/customizations/customization-store';
import { S2E_LAYOUT_TYPE } from '../../../../../../../models/User';

const Radio: React.FC<{ selected: boolean }> = ({selected}) => {
	if (selected) {
		return (
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="10" cy="10" r="9" stroke="#4D79F6" strokeWidth="2"/>
				<circle cx="10" cy="10" r="5" fill="#5678EF"/>
			</svg>
		)
	}

	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z" stroke="#7D86A5" strokeWidth="2"/>
		</svg>
	)
}

const S2ELayoutSelect: React.FC = () => {
	const activeCustomizationStore = customizationStore.getSelectedStore();
	const selectedLayoutType = activeCustomizationStore.switchToExchangeLayoutType;

	return (
		<div className="s2e-layout-select">
			<div className="option" onClick={() => activeCustomizationStore.setS2ELayoutType(S2E_LAYOUT_TYPE.ONE_RECTANGLE)}>
				<img alt="" src={layoutOneRectangle}/>
				<div className="radio">
					<Radio selected={selectedLayoutType === S2E_LAYOUT_TYPE.ONE_RECTANGLE}/>
				</div>
			</div>
			<div className="option" onClick={() => activeCustomizationStore.setS2ELayoutType(S2E_LAYOUT_TYPE.TWO_SQUARES)}>
				<img alt="" src={layoutTwoSquares}/>
				<div className="radio">
					<Radio selected={selectedLayoutType === S2E_LAYOUT_TYPE.TWO_SQUARES}/>
				</div>
			</div>
			<div className="option" onClick={() => activeCustomizationStore.setS2ELayoutType(S2E_LAYOUT_TYPE.TWO_RECTANGLES)}>
				<img alt="" src={layoutTwoRectangles}/>
				<div className="radio">
					<Radio selected={selectedLayoutType === S2E_LAYOUT_TYPE.TWO_RECTANGLES}/>
				</div>
			</div>
			<div className="option" onClick={() => activeCustomizationStore.setS2ELayoutType(S2E_LAYOUT_TYPE.THREE_RECTANGLES)}>
				<img alt="" src={layoutThreeRectangles}/>
				<div className="radio">
					<Radio selected={selectedLayoutType === S2E_LAYOUT_TYPE.THREE_RECTANGLES}/>
				</div>
			</div>
			<div className="option" onClick={() => activeCustomizationStore.setS2ELayoutType(S2E_LAYOUT_TYPE.FOUR_SQUARES)}>
				<img alt="" src={layoutFourSquares}/>
				<div className="radio">
					<Radio selected={selectedLayoutType === S2E_LAYOUT_TYPE.FOUR_SQUARES}/>
				</div>
			</div>
		</div>
	);
};

export default S2ELayoutSelect;
